import React from "react";
import Header from "./Header/Header";
import Todos from "./Todos/Todos";

function App() {
  return (
    <main>
       <Header />
        <Todos />
    </main>
  );
}

export default App;